import { ThemeProvider } from '@mui/material/styles';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import {
  BrowserRouter as Router,
  Navigate,
  Routes,
  Route,
} from 'react-router-dom';

import Loading from './components/elements/loading/Loading';
import PrivateLayoutRoute from './components/layouts/PrivateLayoutRoute';
import NotFound from './pages/errors/404';
import ROUTES from './routes/page-routes';
import { PRIVATE_ROUTE } from './routes/routes';
import { keycloak, initOptions } from './security/keycloak';
import theme from './styles/theme';
import './index.css';

const onTokenRefresh = async ({ token }) =>
  sessionStorage.setItem('user-token', token);

const handleOnEvent = async (event) => {
  if (event === 'onAuthSuccess')
    sessionStorage.setItem('user-token', keycloak.token);

  if (event === 'onTokenExpired') keycloak.updateToken(120);
};

function App() {
  return (
    <ThemeProvider theme={theme}>
      <ReactKeycloakProvider
        authClient={keycloak}
        initOptions={initOptions}
        LoadingComponent={<Loading fullscreen />}
        onEvent={(event, error) => handleOnEvent(event, error)}
        onTokens={onTokenRefresh}
        autoRefreshToken={false}
      >
        <Router>
          <Routes>
            <Route
              path="/"
              element={<Navigate to={PRIVATE_ROUTE.PROJECTS} />}
            />
            {ROUTES.private.map((route) => (
              <Route
                key={route.path}
                path={route.path}
                element={<PrivateLayoutRoute {...route} />}
              />
            ))}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Router>
      </ReactKeycloakProvider>
    </ThemeProvider>
  );
}

export default App;
